const locale: Locale = {
  ko: {
    manage: '회원 정보 관리',
    changePwd: '비밀번호 변경',
  },
  en: {
    manage: 'Account Setting',
    changePwd: 'Change Password',
  },
}

export default locale
